import { render, staticRenderFns } from "./blade-config.vue?vue&type=template&id=6018a052"
import script from "./blade-config.vue?vue&type=script&lang=js"
export * from "./blade-config.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports